import React, { useCallback } from 'react';
import { useUIStore } from '../stores/ui/uiStore';
interface TokenSocialTabProps {
  tokenAddress: string;
}

const TokenSocialTab: React.FC<TokenSocialTabProps> = ({
  tokenAddress
}) => {
  const {
    selectedToken,
    setSelectedToken,
    openTokenDetailModal,
    openSocialDetailModal,
    openNoteDetailModal,
    isTokenDetailModalOpen,
    isSocialDetailModalOpen,
    isNoteDetailModalOpen,
  } = useUIStore();

  const isTokenTabActive = selectedToken?.tokenAddress === tokenAddress && isTokenDetailModalOpen;
  const isSocialTabActive = selectedToken?.tokenAddress === tokenAddress && isSocialDetailModalOpen;
  const isNoteTabActive = selectedToken?.tokenAddress === tokenAddress && isNoteDetailModalOpen;

  const openModal = useCallback((openFn: () => void) => {
    setSelectedToken({
      tokenAddress,
      symbol: selectedToken?.symbol || 'Unknown',
    });
    openFn();
  }, [tokenAddress, setSelectedToken, selectedToken?.symbol]);

  return (
    <div className="flex items-center space-x-2 border-b border-gray-700 mb-4">
      <button
        onClick={() => openModal(openTokenDetailModal)}
        className={`px-6 py-2 text-sm font-medium transition-colors ${
          isTokenTabActive
            ? 'text-white border-b-4 border-blue-500'
            : 'text-gray-400 hover:text-gray-300'
        }`}
      >
        Token
      </button>
      <button
        onClick={() => openModal(openSocialDetailModal)}
        className={`px-6 py-2 text-sm font-medium transition-colors ${
          isSocialTabActive
            ? 'text-white border-b-4 border-purple-500'
            : 'text-gray-400 hover:text-gray-300'
        }`}
      >
        Social
      </button>
      <button
        onClick={() => openModal(openNoteDetailModal)}
        className={`px-6 py-2 text-sm font-medium transition-colors ${
          isNoteTabActive
            ? 'text-white border-b-4 border-green-500'
            : 'text-gray-400 hover:text-gray-300'
        }`}
      >
        Note
      </button>
    </div>
  );
};

export default TokenSocialTab;

